import { render, staticRenderFns } from "./DashR_Search.vue?vue&type=template&id=670a5476"
import script from "./DashR_Search.vue?vue&type=script&lang=js"
export * from "./DashR_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports